<script>
    // CommitChart.js
    import {Bar} from 'vue-chartjs'

    export default {
        extends: Bar,
        data() {
            return {
                gradient: null,
                lastData: this.data
            }
        },
        props: {
            labels: {
                required: true,
                type: Array
            },
            data: {
                required: true,
                type: Array
            },
            percentages: {
                required: true,
                type: Array
            },
            width: {
                default: 1000,
                type: Number
            },
            height: {
                default: 400,
                type: Number
            },
            title: {
                type: String,
                default: ''
            }
        },
        computed: {
            chartData: function () {
                return this.data;
            }
        },
        mounted() {
            this.renderBarChart();
        },
        methods: {
            renderBarChart() {
                this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 400);
                this.$refs.canvas.style['width'] = '2000px';
                this.$refs.canvas.style['max-width'] = this.width + 'px';
                this.$refs.canvas.style['max-height'] = this.height + 'px';
                this.$refs.canvas.style['height'] = '1000px';
                this.gradient.addColorStop(0, '#da2567');
                this.gradient.addColorStop(0.5, '#b92972');
                this.gradient.addColorStop(1, '#752b77');
                const options = {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false,
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                fontStyle: 'bold'
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                fontStyle: 'bold'
                            }
                        }]
                    },
                    title: {
                        display: this.title !== '',
                        text: this.title,
                        fontSize: 12
                    },
                    tooltips: {
                        callbacks: {
                            title: function(tooltipItems) {
                                return typeof tooltipItems[0] !== 'undefined' ? tooltipItems[0].label : '';
                               }.bind(this),
                            label: function(tooltipItem) {
                                return tooltipItem.value + ' ('+this.percentages[tooltipItem.index]+')';
                            }.bind(this)
                        }
                    }
                };
                // Overwriting base render method with actual data.
                this.renderChart({
                    labels: this.labels,
                    datasets: [
                        {
                            backgroundColor: this.gradient,
                            data: this.data
                        }
                    ]
                }, options)
            },
            arrayDiff(a, b) {
                return [...b.reduce((acc, v) => acc.set(v, (acc.get(v) || 0) - 1),
                    a.reduce((acc, v) => acc.set(v, (acc.get(v) || 0) + 1), new Map())
                )].reduce((acc, [v, count]) => acc.concat(Array(Math.abs(count)).fill(v)), []);
            }
        },
        watch: {
            data: function () {
                if (this.arrayDiff(this.data, this.lastData).length > 0) {
                    this.lastData = this.data;
                    this._data._chart.destroy();
                    this.renderBarChart();
                }
            }
        }
    }
</script>

<style scoped>

    canvas {
        background-color: white;
        padding: 12px;
        margin: auto;
    }


</style>